import { backButton } from '@telegram-apps/sdk';
import { useEffect, useRef } from 'react';

/*
 * Системная кнопка «Назад» Telegram.
 *
 * Своя кнопка не рисуется: так требуют стек.md и чеклист функции.
 * Игрок ждёт стрелку в шапке Telegram, а не дублирующую её кнопку внизу.
 *
 * onBack === null — кнопка скрыта (первый экран, главное окно игры).
 */
export function useTelegramBack(onBack: (() => void) | null, enabled = true): void {
  // Ссылка на актуальный обработчик: переподписка на каждый рендер
  // мигала бы кнопкой.
  const handlerRef = useRef(onBack);
  handlerRef.current = onBack;

  const visible = onBack !== null;

  useEffect(() => {
    if (!enabled) return;
    // Вне Telegram SDK бросает UnknownEnvError даже из isAvailable():
    // исключение в эффекте уронило бы весь экран. Без SDK кнопки просто нет.
    let off: VoidFunction | undefined;
    try {
      if (!backButton.mount.isAvailable()) return;
      if (!backButton.isMounted()) backButton.mount();

      if (!visible) {
        if (backButton.hide.isAvailable()) backButton.hide();
        return;
      }

      if (backButton.show.isAvailable()) backButton.show();
      if (backButton.onClick.isAvailable()) {
        off = backButton.onClick(() => handlerRef.current?.());
      }
    } catch {
      return;
    }

    return () => {
      try {
        off?.();
        if (backButton.hide.isAvailable()) backButton.hide();
      } catch {
        // Окружение пропало между показом и скрытием — скрывать нечего.
      }
    };
  }, [visible, enabled]);
}
